module.exports = __webpack_public_path__ + "img/66.c58b6b75.png";